import { Colors, Services, getServiceNameKebabCase, getServiceNameViaPoint, getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'
import { EUrlShortenerSettingsDomainsStates } from '@sigmasms/shared-types'

import { globalErrorHandler, icons, request } from '@/utils'

const pathToAPI = getServicePathToAPI(Services['url-shortener-settings/domains'])

export const serviceNameViaPoint = getServiceNameViaPoint(Services['url-shortener-settings/domains'])
export const serviceNameKebabCase = getServiceNameKebabCase(Services['url-shortener-settings/domains'])

export const urlShortenerSettingsDomainsStates = {
  [EUrlShortenerSettingsDomainsStates.inactive]: {
    icon: icons.clear,
    color: Colors.error
  },
  [EUrlShortenerSettingsDomainsStates.pending]: {
    icon: icons.schedule,
    color: Colors.primary
  },
  [EUrlShortenerSettingsDomainsStates.active]: {
    icon: icons.done,
    color: Colors.success
  }
}

export const checkDNS = {
  data() {
    return {
      checkDNSLoading: false,
      initialDomainState: undefined,
      initialOwnerId: undefined
    }
  },

  computed: {
    canCheckDNS() {
      if (this.checkDNSLoading) {
        return false
      }
      if (this.initialOwnerId === this.account?.id) {
        if (this.initialDomainState === EUrlShortenerSettingsDomainsStates.pending) {
          return true
        }
      }

      return false
    }
  },

  mounted() {
    this.initialDomainState = this.value?.state
    this.initialOwnerId = this.value?.ownerId
  },

  methods: {
    async checkDNS(id) {
      if (this.canCheckDNS) {
        try {
          this.checkDNSLoading = true
          const response = await request.get(joinURLPath(pathToAPI, id, 'check-dns'))
          if (response) {
            this.addSnackbar({
              text: this.getTranslate(`${serviceNameViaPoint}.snackbars.dnsChecked`),
              type: 'success'
            })
            if (response.verified) {
              this.addSnackbar({
                text: this.getTranslate(`${serviceNameViaPoint}.snackbars.domainVerified`),
                type: 'success'
              })
            } else {
              this.addSnackbar({
                text: this.getTranslate(`${serviceNameViaPoint}.snackbars.domainNotVerified`),
                type: 'error'
              })
            }
          }
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.checkDNSLoading = false
        }
      }
    }
  }
}
